/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import Link from 'next/link';
import * as styles from './CategoryList.style';
import { CategoryItem } from '../../types';

export interface CategoryListProps {
  items: CategoryItem[],
  activeId?: string,
}

const CategoryList: FunctionComponent<CategoryListProps> = ({
  items,
  activeId,
}) => (
  <ul>
    {items.map(({ id, label, urlObject }) => (
      <li
        key={label}
        css={styles.item}
        data-ref="category-item"
        $active={activeId === id}
      >
        <Link
          href={urlObject.url}
          as={urlObject.as}
        >
          {label}
        </Link>
      </li>
    ))}
  </ul>
);

export default CategoryList;
